import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_EMPLOYMENT_VERIFICATION_GET_BY_APPLICATION_ID } from 'api/actionTypes';

export default async function getByApplicationId({ state, apiClient }, { householdApplicationId }) {
  typeCheck('householdApplicationId::PositiveNumber', householdApplicationId);

  const incomeVerification = await apiClient.postWithState({
    action: SR_API_ACTION_EMPLOYMENT_VERIFICATION_GET_BY_APPLICATION_ID,
    state: state,
    payload: { householdApplicationId },
  });

  return incomeVerification;
}
